const CAPITAL_CITIES = {
  ae: 'Abu Dhabi',
  ai: 'The Valley',
  am: 'Yerevan',
  ar: 'Buenos Aires',
  as: 'Pago Pago',
  at: 'Vienna',
  au: 'Sydney',
  az: 'Baku',
  ba: 'Sarajevo',
  bd: 'Dhaka',
  be: 'Brussels',
  bg: 'Sofia',
  bh: 'Manama',
  bn: 'Bandar Seri Begawan',
  bo: 'La Paz',
  br: 'Rio de Janeiro',
  ca: 'Toronto',
  cd: 'Kinshasa',
  ch: 'Zurich',
  ci: 'Yamoussoukro',
  cl: 'Santiago',
  cn: 'Beijing',
  co: 'Bogotá',
  cr: 'San José',
  cy: 'Nicosia',
  cz: 'Prague',
  de: 'Berlin',
  dj: 'Djibouti',
  dk: 'Copenhagen',
  do: 'Santo Domingo',
  dz: 'Algiers',
  ec: 'Quito',
  ee: 'Tallinn',
  eg: 'Cairo',
  es: 'Madrid',
  et: 'Addis Ababa',
  fi: 'Helsinki',
  fr: 'Paris',
  ge: 'Tbilisi',
  gh: 'Accra',
  gi: 'Gibraltar',
  gm: 'Banjul',
  gp: 'Basse Terre',
  gr: 'Athens',
  gt: 'Guatemala City',
  hk: 'Hong Kong',
  hn: 'Tegucigalpa',
  hr: 'Zagreb',
  ht: 'Port-au-Prince',
  hu: 'Budapest',
  id: 'Jakarta',
  ie: 'Dublin',
  il: 'Jerusalem',
  in: 'New Delhi',
  is: 'Reykjavík',
  it: 'Rome',
  je: 'Saint Helier',
  jm: 'Kingston',
  jo: 'Amman',
  jp: 'Tokyo',
  ke: 'Nairobi',
  kh: 'Phnom Penh',
  kr: 'Seoul',
  kz: 'Nur-Sultan',
  li: 'Liechtenstein',
  lk: 'Colombo',
  lt: 'Vilnius',
  lu: 'Luxembourg',
  lv: 'Riga',
  ly: 'Tripoli',
  ma: 'Rabat',
  md: 'Chisinau',
  mn: 'Ulaanbaatar',
  mt: 'Valletta',
  mu: 'Port Louis',
  mx: 'Mexico City',
  my: 'Kuala Lumpur',
  na: 'Windhoek',
  nc: 'Noumea',
  ng: 'Abuja',
  ni: 'Managua',
  nl: 'Amsterdam',
  no: 'Oslo',
  np: 'Kathmandu',
  nu: 'Alofi',
  nz: 'Wellington',
  om: 'Muscat',
  pa: 'Panama City',
  pe: 'Lima',
  ph: 'Manila',
  pl: 'Warsaw',
  pr: 'San Juan',
  pt: 'Lisbon',
  py: 'Asunción',
  qa: 'Doha',
  ro: 'Bucharest',
  rs: 'Belgrade',
  ru: 'Moscow',
  rw: 'Kigali',
  sa: 'Riyadh',
  se: 'Stockholm',
  sg: 'Pulau Ujong',
  si: 'Ljubljana',
  sk: 'Bratislava',
  sm: 'San Marino',
  sn: 'Dakar',
  sv: 'San Salvador',
  th: 'Bangkok',
  to: 'Nuku\'alofa',
  tr: 'Istanbul',
  tt: 'Port of Spain',
  tw: 'Taipei',
  ua: 'Kyiv',
  ug: 'Kampala',
  uk: 'London',
  us: 'New York',
  uy: 'Montevideo',
  uz: 'Tashkent',
  vc: 'Kingstown',
  ve: 'Caracas',
  vn: 'Hanoi',
  za: 'Cape Town',
  zm: 'Lusaka'
};

export const getCountryCapital = country => {
  return CAPITAL_CITIES[country];
};
